var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWideCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 8C6.61793 8 6.5692 7.9814 6.53199 7.9442L4 5.4122L1.46801 7.9442C1.3936 8.0186 1.27306 8.0186 1.19866 7.9442L0.0558029 6.80134C-0.018601 6.72694 -0.018601 6.6064 0.0558029 6.53199L2.5878 4L0.0558029 1.46801C-0.018601 1.3936 -0.018601 1.27306 0.0558029 1.19866L1.19866 0.0558029C1.27306 -0.018601 1.3936 -0.018601 1.46801 0.0558029L4 2.5878L6.53199 0.0558029C6.6064 -0.018601 6.72694 -0.018601 6.80134 0.0558029L7.9442 1.19866C8.0186 1.27306 8.0186 1.3936 7.9442 1.46801L5.4122 4L7.9442 6.53199C8.0186 6.6064 8.0186 6.72694 7.9442 6.80134L6.80134 7.9442C6.76414 7.9814 6.7154 8 6.66667 8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWideCross);
export default ForwardRef;